<template>
    <div class="period-item-card">
      <slot name="btn" class="btn">

      </slot>
      <div class="title" @click="updateHandle">
        {{data.name}}
      </div>
      <div class="row info" v-if="data.base!='1'">
        距离基线<label>{{data.baseDay!=null && data.baseDay!=undefined ?data.baseDay: '-'}}</label>天
      </div>
      <div class="row info" v-else>
        基线事件
      </div>
      <div class="row module info">
        <div class="item" v-for="(item,index) in (data.moduleList || [])">
          {{item.name}}
        </div>
      </div>
      <div class="row info">
        时间成本：{{data.time || '-'}}分钟
      </div>
      <div class="row info">
        投入成本：{{data.price || '-'}}元
      </div>
    </div>
</template>

<script>
  export default {
    name: 'PeriodItemCard',
    props:{
      data:{
        type:Object,
        default:()=>{
          return {}
        }
      }
    },
    data(){
      return {

      }
    },
    mounted(){},
    methods:{
      updateHandle(){
        this.$emit('updateHandle',JSON.parse(JSON.stringify(this.data)))
      }
    }
  }
</script>

<style scoped lang="less">
  .period-item-card{
    min-width: 150px;
    border: 1px dashed  rgba(0,0,0,0.1);
    border-radius: 5px;
    padding: 10px;
    .title{
      font-size: 18px;
      font-weight: bold;
    }
    .row{
      margin-top: 10px;
    }
    .module{
      border: 1px dashed  rgba(0,0,0,0.1);
      border-radius: 5px;
      padding: 5px;
      margin: 10px -5px 0px -5px;
    }
    .info{
      font-size: 16px;
    }
  }
</style>